import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Tooltip, Typography, withStyles } from '@material-ui/core';

import { isAuthenticated } from '../../helpers/authenticate';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import {useStyles} from './ConfiguracoesStyles';
import clsx from 'clsx';
import Avatar from '@material-ui/core/Avatar';
import { Values } from '../../values/Values';
import Hidden from '@material-ui/core/Hidden';
import {MdAccountBalance} from 'react-icons/md'
import {MdEventNote} from 'react-icons/md'
import {MdHelpOutline} from 'react-icons/md'
import CardActionArea from '@material-ui/core/CardActionArea';
import ConfiguracoesGerais from './components/ConfiguracoesGerais/ConfiguracoesGerais';
import { getEmpresaPrincipal } from '../../services/EmpresaService';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import ConfiguracoesVisitas from './components/ConfiguracoesVisitas/ConfiguracoesVisitas';
import SobreSistema from './components/SobreSistema/SobreSistema';


const Configuracoes = ({history}) => {
  const classes = useStyles();
  const [abrirConfiguracoesGerais, setAbrirConfiguracoesGerais] = useState(false);
  const [abrirConfiguracoesVisitas, setAbrirConfiguracoesVisitas] = useState(false);
  const [abrirSobreSistema, setAbrirSobreSistema] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [empresa, setEmpresa] = useState({
    cnpj: '',
    email: '',
    horaEmpresa: undefined,
    idEmpresa: '',
    nomeFantasia: '',
    razaoSocial: '',
  });

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  const TooltipCustomizado = withStyles((theme) => ({
    tooltip: {
      backgroundColor: Values.cores.corPrimaria,
      color: Values.cores.branco,
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);



  async function abrirDialogConfiguracoesGerais(event) {
    try{
      event.preventDefault();
      setLoading(true);
      let retorno = await getEmpresaPrincipal();
      setLoading(false);
      if(retorno.isSuccess) {
        setEmpresa(retorno.result);
        setAbrirConfiguracoesGerais(true);
      }
      else {
        setTypeSnack('error');
        setMessageSnack(retorno.message);
        setShowMessageSnack(true)
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true)
    }
  }

  async function abrirDialogConfiguracoesVisitas(event) {
    try{
      event.preventDefault();
      setLoading(true);
      let retorno = await getEmpresaPrincipal();
      setLoading(false);
      if(retorno.isSuccess) {
        setEmpresa(retorno.result);
        setAbrirConfiguracoesVisitas(true);
      }
      else {
        setTypeSnack('error');
        setMessageSnack(retorno.message);
        setShowMessageSnack(true)
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true)
    }
  }

  async function abrirDialogSobreSistema(event) {
    try{
      event.preventDefault();
      setAbrirSobreSistema(true);
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true)
    }
  }

  return (
    <Grid
      container
      className={clsx({
        [classes.root]: true
      })}
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <SnackbarCustom
          verticalOrientation='bottom'
          horizontalOrientation='center'
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <ProgressFullScreen
          open={loading}
          setOpen={setLoading}
        />
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <ConfiguracoesGerais
          open={abrirConfiguracoesGerais}
          setOpen={setAbrirConfiguracoesGerais}
          empresa={empresa}
          setEmpresa={setEmpresa}
          setLoading={setLoading}
          setShowMessageSnack={setShowMessageSnack}
          setMessageSnack={setMessageSnack}
          setTypeSnack={setTypeSnack}
        />
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <ConfiguracoesVisitas
          open={abrirConfiguracoesVisitas}
          setOpen={setAbrirConfiguracoesVisitas}
          empresa={empresa}
          setEmpresa={setEmpresa}
          setLoading={setLoading}
          setShowMessageSnack={setShowMessageSnack}
          setMessageSnack={setMessageSnack}
          setTypeSnack={setTypeSnack}
        />
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <SobreSistema
          open={abrirSobreSistema}
          setOpen={setAbrirSobreSistema}
        />
      </Grid>
      <Hidden xsDown>
        <Grid
          item
          md={12}
          xs={12}
        >
          <div
            className={clsx({
              [classes.divImagemPrincipal]: true
            })}
          >
            <img
              alt="Under development"
              src="/images/telaConfiguracoes/imagemFundaTelaConfiguracoes.png"
              className={clsx({
                [classes.imagemPrincipal]: true
              })}
            >
            </img>
          </div>
        </Grid>
      </Hidden>
      <Grid
        item
        md={4}
        xs={12}
      >
        <Card
          variant='elevation'
          elevation={7}
          className={clsx({
            [classes.cardConfiguracoes]: true
          })}
        >
          <TooltipCustomizado
            title={'Clique para editar as configurações gerais.'}
          >
            <CardActionArea
              onClick={e => abrirDialogConfiguracoesGerais(e) }
            >
              <CardContent>
                <Grid
                  container
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                    className={clsx({
                      [classes.gridAvatarCards]: true
                    })}

                  >
                    <Avatar
                      className={clsx({
                        [classes.avatarCards]: true
                      })}
                    >
                      <MdAccountBalance
                        className={clsx({
                          [classes.iconAvatarCards]: true
                        })}
                      />
                    </Avatar>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    className={clsx({
                      [classes.gridTextoCards]: true
                    })}

                  >
                    <Typography
                      color="textSecondary"
                      gutterBottom
                      variant="body2"
                      component='h6'
                      className={clsx({
                        [classes.textoCards]: true
                      })}
                    >
                      CONFIGURAÇÕES GERAIS
                    </Typography>
                  </Grid>
                </Grid>

              </CardContent>
            </CardActionArea>
          </TooltipCustomizado>
        </Card>
      </Grid>
      <Grid
        item
        md={4}
        xs={12}
        syle={{
          padding: 50
        }}
      >
        <Card
          variant='elevation'
          elevation={7}
          className={clsx({
            [classes.cardConfiguracoes]: true
          })}
        >
          <TooltipCustomizado
            title={'Clique para editar as configurações da visita.'}
          >
            <CardActionArea
              onClick={e => abrirDialogConfiguracoesVisitas(e) }
            >
              <CardContent>
                <Grid
                  container
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                    className={clsx({
                      [classes.gridAvatarCards]: true
                    })}

                  >
                    <Avatar
                      className={clsx({
                        [classes.avatarCards]: true
                      })}
                    >
                      <MdEventNote
                        className={clsx({
                          [classes.iconAvatarCards]: true
                        })}
                      />
                    </Avatar>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    className={clsx({
                      [classes.gridTextoCards]: true
                    })}

                  >
                    <Typography
                      color="textSecondary"
                      gutterBottom
                      variant="body2"
                      component='h6'
                      className={clsx({
                        [classes.textoCards]: true
                      })}
                    >
                      CONFIGURAÇÕES DA VISITA
                    </Typography>
                  </Grid>
                </Grid>

              </CardContent>
            </CardActionArea>
          </TooltipCustomizado>

        </Card>

      </Grid>
      <Grid
        item
        md={4}
        xs={12}
        syle={{
          padding: 50
        }}
      >
        <Card
          variant='elevation'
          elevation={7}
          className={clsx({
            [classes.cardConfiguracoes]: true
          })}
        >
          <TooltipCustomizado
            title={'Clique para saber mais informações do sistema.'}
          >
            <CardActionArea
              onClick={e => abrirDialogSobreSistema(e) }
            >
              <CardContent>
                <Grid
                  container
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                    className={clsx({
                      [classes.gridAvatarCards]: true
                    })}

                  >
                    <Avatar
                      className={clsx({
                        [classes.avatarCards]: true
                      })}
                    >
                      <MdHelpOutline
                        className={clsx({
                          [classes.iconAvatarCards]: true
                        })}
                      />
                    </Avatar>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    className={clsx({
                      [classes.gridTextoCards]: true
                    })}

                  >
                    <Typography
                      color="textSecondary"
                      gutterBottom
                      variant="body2"
                      component='h6'
                      className={clsx({
                        [classes.textoCards]: true
                      })}
                    >
                      SOBRE O SISTEMA
                    </Typography>
                  </Grid>
                </Grid>

              </CardContent>
            </CardActionArea>
          </TooltipCustomizado>
        </Card>

      </Grid>
    </Grid>
  );
};

export default Configuracoes;
